/* import __COLOCATED_TEMPLATE__ from './code-snippet.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();